import { render, staticRenderFns } from "./code.vue?vue&type=template&id=43bf9fb8"
import script from "./code.vue?vue&type=script&lang=js"
export * from "./code.vue?vue&type=script&lang=js"
import style0 from "./code.vue?vue&type=style&index=0&id=43bf9fb8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports